import { useLocalization } from '@magicdoorinc/ui';
import type { Component } from 'solid-js';

const BreakpointIndicator: Component = () => {
  const { t } = useLocalization();
  return (
    <div class="flex items-center gap-2 rounded-md px-2">
      <span class="text-xs font-medium text-gray-600">{t('Screen')}</span>
      <div class="flex items-center gap-1">
        <span class="block font-mono text-xs font-semibold text-blue-600 sm:hidden">xs</span>
        <span class="hidden font-mono text-xs font-semibold text-green-600 sm:block md:hidden">sm</span>
        <span class="hidden font-mono text-xs font-semibold text-yellow-600 md:block lg:hidden">md</span>
        <span class="hidden font-mono text-xs font-semibold text-orange-600 lg:block xl:hidden">lg</span>
        <span class="hidden font-mono text-xs font-semibold text-red-600 xl:block 2xl:hidden">xl</span>
        <span class="hidden font-mono text-xs font-semibold text-purple-600 2xl:block">2xl</span>
      </div>
    </div>
  );
};

export default BreakpointIndicator;
